import React, { useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { notifyError } from "../../../helpers/helpers";
import documentList from "../../../jsonData/uploadDocuments.json";
import { useDispatch, useSelector } from "react-redux";
import imageCompression from 'browser-image-compression';
import { uploadInitailReqiuredDoucment } from "../../../redux/action/document";
import { ClipLoader } from "react-spinners";

function UploadDocument() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.loading);
  const isLaptop = useMediaQuery({ query: "(max-width: 1400px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 999px)" });
  const [documentFileList, setDocumentFileList] = useState([]);
  const fileInputRefs = useRef(documentList.map(() => React.createRef()));

  const handleSubmitButton = () => {
    const formData = new FormData();
    documentFileList.forEach((file, index) => {
      if (file) {
        formData.append(documentList[index]?.uploadfileName, file);
      }
    });

    dispatch(
      uploadInitailReqiuredDoucment(formData, setDocumentFileList, navigate)
    );
  };

  const isAllFieldsFilled =
    documentFileList[0] !== undefined && documentFileList[1] !== undefined;

  const handleFileUpload = async (event, index) => {
    const file = event.target.files[0];
    event.target.value = null;

    if (!file) return;

    const maxSize = 100 * 1024 * 1024;
    if (file.size > maxSize) {
      return notifyError(
        "File size exceeds 30MB. Please choose a smaller file."
      );
    }

    const alreadyStoreFile = documentFileList.some(
      (item) => item && item.lastModified === file?.lastModified
    );

    if (alreadyStoreFile) {
      return notifyError(
        "Image upload failed: This image is already uploaded."
      );
    }

    if (file) {
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg+xml",
        "image/webp",
        "application/pdf",
      ];
      if (validTypes.includes(file.type)) {
        try {
          let compressedFile = file;
          if (file.type !== "application/pdf") {
            const options = {
              maxSizeMB: 0.1,
              maxWidthOrHeight: 1080,
              useWebWorker: true,
            };

            const compressedBlob = await imageCompression(file, options);
            compressedFile = new File(
              [compressedBlob],
              file.name,
              { type: file.type }
            );
          }
          setDocumentFileList((prevData) => {
            const newData = [...prevData];
            newData[index] = compressedFile;
            return newData;
          });
        } catch (error) {
          console.error("Compression error:", error);
          notifyError("Failed to compress file.");
        }

        // setDocumentFileList((prevData) => {
        //   const newData = [...prevData];
        //   newData[index] = file;
        //   return newData;
        // });
      } else {
        notifyError(
          "Unsupported file format. Only JPG, JPEG, PNG, SVG, PDF and WEBP files are allowed."
        );
      }
    }
  };

  const handleSpanClick = (index) => {
    fileInputRefs.current[index].current.click();
  };

  // Function to remove a file from the documentFileList array
  const handleRemoveFile = (index) => {
    setDocumentFileList((prevData) => {
      const newData = [...prevData];
      newData[index] = undefined;
      return newData;
    });
  };


  return (
    <div className="auth-from" style={{ width: isLaptop ? "700px" : "auto" }}>
      <div className={`flex  full-width`}>
        <span
          className="material-symbols-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>
      </div>

      <div style={{ width: isTablet ? "100%" : "420px", margin: "auto" }}>
        <h3 className="flex justify-center mb-2">UPLOAD YOUR DOCUMENTS</h3>
        <div>
          {documentList.map((items, index) => (
            <span key={items.id}>
              <label className="black-text font-16px">
                {items.uploadfileName.toUpperCase()}
                {index < 2 && <span className="red-text">*</span>}
              </label>

              <span
                className="valign-wrapper space-between mb-1 pointer border-1px border-radius-12"
                style={{ padding: "12px" }}
                onClick={() => handleSpanClick(index)}
              >
                <p>{documentFileList[index]?.name || "No file chosen"}</p>
                {documentFileList[index] ? (
                  <span
                    className="material-symbols-outlined zoom-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveFile(index);
                    }}
                  >
                    close
                  </span>
                ) : (
                  <span className="material-icons-outlined">file_upload</span>
                )}

                <input
                  type="file"
                  id={`file-input-${items.id}`}
                  onChange={(event) => handleFileUpload(event, index)}
                  style={{ display: "none" }}
                  ref={fileInputRefs.current[index]}
                />
              </span>
            </span>
          ))}
          <div className="flex justify-center mt-2">
            <button
              className={`button-style bold ${!isAllFieldsFilled
                ? "grey lighten-2 grey-text text-darken-1"
                : "cercle-purple white-text"
                } pointer`}
              style={{ padding: "15px 55px" }}
              onClick={handleSubmitButton}
              disabled={!isAllFieldsFilled}
            >
              {loading ? <ClipLoader color="#fff" size={20} /> : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UploadDocument;
